import InactiveWarningIcon from "../../../../svg/inactiveWarningIcon";
import CandidUploadTriggerMenu from "./candidUploadTriggerMenu";
import { useCandidUploadActions } from "./hooks/useCandidUploadActions";

const NoCandidDataFound = () => {
  const { handleDropdownActionClick } = useCandidUploadActions();
  return (
    <div className="no-candid-data-found--container flex h-full flex-col items-center justify-center gap-4">
      <div className="icon mr-12">
        <InactiveWarningIcon />
      </div>
      <div className="text-center text-sm font-medium text-primaryGray-2">
        No Candid upload has been triggered yet
      </div>
      <div className="button-container">
        <CandidUploadTriggerMenu onAction={handleDropdownActionClick} />
      </div>
    </div>
  );
};

export default NoCandidDataFound;
